import { configureStore } from "@reduxjs/toolkit";
import blogsReducer from "../features/blogs/blogsSlice";
import blogReducer from "../features/blog/blogSlice";
import filterReducer from "../features/filters/filtersSlice";
import buttonActionReducer from "../features/buttonAction/buttonActionSlice";
import relatedPostsReducer from "../features/relatedPosts/relatedPostsSlice";

export const store = configureStore({
  reducer: {
    blogs: blogsReducer,
    blog: blogReducer,
    filter: filterReducer,
    buttonAction: buttonActionReducer,
    relatedPosts: relatedPostsReducer,
  },
});
